export enum Modifiers {
  Shift = 0x10000,
  Control = 0x20000,
  Alt = 0x40000,
  MacControl = 0x80000,
}

export enum MouseEventType {
  Down = 0,
  Up = 1,
  Move = 2,
  Leave = 3,
}

export enum KeyEventType {
  Down = 0,
  Up = 1,
  Press = 2,
}

export enum AxCursorType {
  Default,
  Arrow,
  Cross,
  WaitCursor,
  IBeam,
  Hand,
  SizeNWSE,
  SizeNS,
  SizeNESW,
  SizeWE,
  SizeAll,
  HSplit,
  VSplit,
  OpenHand,
  ClosedHand,
  Add,
  Remove,
  Dropper,
  Custom,
  Comment,
}
